import React, { useEffect, useState } from 'react';
import { Table, Button, Space, Typography, message, Spin, Popconfirm } from 'antd';
import axios from 'axios';

const { Title, Text } = Typography;

const AttenteValidation = () => {
  const [influenceurs, setInfluenceurs] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');

  // Fonction pour charger les influenceurs désactivés
  const fetchInfluenceurs = async () => {
    setLoading(true);
    try {
      const res = await axios.get('http://localhost:8080/admin/api/getInfluenceurs', {
        headers: {
          Authorization: 'Basic ' + token,
        },
      });

      // Filtrer ceux qui n'ont pas encore été validés
      const nonActives = res.data.filter(i => !i.userSystem?.statut_compte);
      setInfluenceurs(nonActives);
    } catch (error) {
      console.error(error);
      message.error("Erreur lors du chargement des influenceurs.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInfluenceurs();
  }, []);

  const handleActiverCompte = async (id) => {
    try {
      await axios.put(`http://localhost:8080/admin/api/activer-influenceur/${id}`, null, {
        headers: {
          Authorization: 'Basic ' + token,
        },
      });
      message.success("Compte activé avec succès !");
      fetchInfluenceurs(); // Recharger la liste
    } catch (err) {
      console.error(err);
      message.error("Échec de l’activation du compte.");
    }
  };

  const columns = [
    {
      title: 'Nom',
      dataIndex: ['userSystem', 'nom'],
      key: 'nom',
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: 'Prénom',
      dataIndex: ['userSystem', 'prenom'],
      key: 'prenom',
    },
    {
      title: 'Téléphone',
      dataIndex: ['userSystem', 'telephone'],
      key: 'telephone',
    },
    {
      title: 'Email',
      dataIndex: ['userSystem', 'email'],
      key: 'email',
      render: (email) => <a href={`mailto:${email}`}>{email}</a>,
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Popconfirm
          title="Activer ce compte ?"
          onConfirm={() => handleActiverCompte(record.id)}
          okText="Oui"
          cancelText="Non"
        >
          <Button type="primary">Valider</Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <Title level={3}>Influenceurs en attente de validation</Title>

      {loading ? (
        <Space style={{ width: '100%', justifyContent: 'center', padding: '2rem' }}>
          <Spin tip="Chargement..." />
        </Space>
      ) : (
        <Table
          dataSource={influenceurs}
          columns={columns}
          rowKey="id"
          pagination={{ pageSize: 5 }}
          bordered
        />
      )}
    </div>
  );
};

export default AttenteValidation;
